import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";

import { AcmeWide, Body, Header4, ProximaNova } from "./typography";
import RatingStars from "./RatingStars";
import { Colors } from "./styles/Colors";
import { Link, navigate } from "gatsby";
import { SecondaryButton, TertiaryButton } from "./Button";
import Breakpoints from "./styles/Breakpoints";
import { SUBS_ENABLED } from "../utils/settings";

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 300px;

  button {
    display: none;
  }

  .gatsby-image-wrapper {
    position: absolute !important;
    top: 0;
    width: 100%;
    height: 100%;
    transition: opacity 1s cubic-bezier(0.22, 1, 0.36, 1);
  }

  .gatsby-image-wrapper:nth-child(2) {
    opacity: 0;
  }

  &:hover {
    .gatsby-image-wrapper:first-child {
      opacity: 0;
    }

    .gatsby-image-wrapper:nth-child(2) {
      opacity: 1;
    }

    button {
      display: block;
    }
  }

  @media ${Breakpoints.tablet} {
    height: 500px;

    > div:last-child {
      position: absolute;

      width: 100%;
      bottom: 16px;
      left: 50%;
      transform: translateX(-50%);

      display: flex;

      justify-content: center;

      > button {
        max-width: 180px;
        margin: 0 8px;
        border: 0;
        cursor: pointer;
      }
    }
  }
`;

const Wrapper = styled.a`
  color: inherit;
  text-decoration: none;

  display: inline-flex;
  flex-direction: column;

  flex: 1 0 100%;

  width: 310px;

  cursor: pointer;

  ${ImageWrapper} {
    margin: 0 0 32px;
  }

  ${Body} {
    margin: 24px 0;
    max-width: 400px;
    color: ${Colors.greyLight};
  }

  > div:last-child {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    > ${SecondaryButton} {
      margin: 8px 0;
    }
  }

  @media ${Breakpoints.tablet} {
    width: 100%;
    max-width: 560px;
    height: unset;

    ${Body} {
      margin: 12px 0;
    }

    > div:nth-child(2) > div:first-child {
      display: flex;

      justify-content: space-between;
      align-items: center;
    }

    > div:last-child {
      flex-grow: 0;

      ${SecondaryButton}, ${TertiaryButton} {
        display: none;
      }
    }
  }
`;

const Price = styled.span`
  font-family: ${AcmeWide};
  font-size: 14px;

  color: ${Colors.grey};

  @media ${Breakpoints.tablet} {
    font-size: 18px;
  }
`;

const VolumeOrSize = styled.span`
  display: none;

  margin: 8px 0 2px;

  @media ${Breakpoints.tablet} {
    display: block;

    font-family: ${ProximaNova};
    font-size: 14px;
    color: #828282;
  }
`;

export default function ProductCard({
  name,
  slug,
  price,
  volumeOrSize,
  description,
  rating,
  image,
  hoverImage,
  onSubscribe,
  onBuy,
}) {
  function onNavigate() {
    navigate(`/products/${slug}`);
  }

  return (
    <Wrapper>
      <ImageWrapper>
        <div onClick={onNavigate}>
          <Img
            backgroundColor={Colors.cream3}
            fluid={image}
            onClick={onNavigate}
            fadeIn
          />
          <Img
            backgroundColor={Colors.cream3}
            fluid={hoverImage}
            onClick={onNavigate}
          />
        </div>
        <div>
          {SUBS_ENABLED && onSubscribe && (
            <SecondaryButton onClick={onSubscribe}>Subscribe</SecondaryButton>
          )}
          {onBuy && <TertiaryButton onClick={onBuy}>Buy Now</TertiaryButton>}
        </div>
      </ImageWrapper>
      <div onClick={onNavigate}>
        <div>
          <Header4>{name}</Header4>
          <Price>
            {new Intl.NumberFormat(process.env.GATSBY_LOCALE, {
              style: "currency",
              currency: process.env.GATSBY_LOCALE === "en-US" ? "USD" : "GBP",
            }).format(price)}
          </Price>
        </div>
        <VolumeOrSize>{volumeOrSize}</VolumeOrSize>
        <Body>{description}</Body>
      </div>
      <div>
        {rating && (
          <RatingStars score={rating?.score} count={rating?.totalReviews} />
        )}
        {SUBS_ENABLED && onSubscribe && (
          <SecondaryButton onClick={onSubscribe}>Subscribe</SecondaryButton>
        )}
        {onBuy && <TertiaryButton onClick={onBuy}>Buy Now</TertiaryButton>}
      </div>
    </Wrapper>
  );
}
